import { translate } from 'utils/translations'
import * as Styled from './styled'
import { Text } from 'common-components'
import { T } from 'consts/translationKeys'
import { useOpenUpgradePopup } from 'hooks/useOpenUpgradePopup'

interface IRefillButtonProps {
  referer: string
}

const RefillButton = ({ referer }: IRefillButtonProps) => {
  const openUpgradePopup = useOpenUpgradePopup()

  return (
    <Styled.RefillCreditsLink>
      <Text
        type="h4"
        color="primaryDark"
        onClick={() => openUpgradePopup({ ref: referer })}
      >
        {translate(T.REFILL_CREDITS_LABEL)}
      </Text>
    </Styled.RefillCreditsLink>
  )
}

export default RefillButton
